import { useEffect, useState } from "react";
import { PROJECT } from "@/data/project";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "ubicacion", label: "Ubicación" },
    { id: "renders", label: "Renders" },
    { id: "datos", label: "Datos" },
    { id: "proyecto", label: "Proyecto" },
    { id: "contacto", label: "Contacto" },
  ];

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-[var(--co-border)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className={`font-display font-extrabold text-lg tracking-tight ${
            scrolled ? "text-[var(--co-primary)]" : "text-white"
          }`}
        >
          COSTA OESTE <span className="text-[var(--co-accent)]">PLAZA</span>
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <li key={l.id}>
              <a
                data-testid={`nav-link-${l.id}`}
                href={`#${l.id}`}
                className={`text-sm font-medium tracking-wide transition-colors ${
                  scrolled
                    ? "text-[var(--co-text-muted)] hover:text-[var(--co-primary)]"
                    : "text-white/80 hover:text-white"
                }`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          data-testid="nav-cta"
          href="#contacto"
          className="hidden sm:inline-flex items-center gap-2 bg-[var(--co-accent)] hover:bg-[var(--co-accent-light)] text-white px-5 py-2.5 text-xs font-bold uppercase tracking-[0.15em] transition-colors"
        >
          Reservar local
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
